import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Banner from "../../components/common/banner/banner";
import { Images } from "../../assets";
import {
  getMediationPageData,
  updateDownloadCount,
} from "../../redux/mediation/action";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import MetaTags from "../../components/metaTags/seoTags";
import ActionFeedback from "../../components/common/takeActions/actionFeedback";
import PageStats from "../../components/pageStats/pageStats";
import BreadcrumbSec from "../../components/common/breadcrumb/breadcrumb";
import { helperFunction } from "../../utils/helperFunctions";
import { Col, Container, Image, Row } from "react-bootstrap";
import ArbitratorConcept from "./mediationConcept/arbitratorConcept";
import { useTranslation } from "react-i18next";

const Arbitrator = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mediation = useSelector((state) => state.mediation);
  const rawToken = helperFunction.getToken();
  const userToken =
    typeof rawToken === "string" ? rawToken : Object.values(rawToken || {})[0];
  const { mediationPageData } = mediation;
  useEffect(() => {
    dispatch(getMediationPageData());
  }, []);

  return (
    <>
      <MetaTags
        title="Arbitrator"
        metaTitle="Arbitrator"
        description="Arbitrator"
        keywords="Arbitrator"
      />
      {mediation?.loader ? (
        <FullPageLoader />
      ) : (
        <>
          <Banner
            img={Images?.mediationBanner}
            title="Arbitrator"
            content="Arbitrators facilitate the resolution of commercial conflicts through specialized arbitrators, promoting a swift and effective means of settling disputes"
            loader={mediationPageData?.loader}
            addButton={{
              enabled: true,
              secondButton: {
                text: t("arbitrator.applyForArbitrator"),
                link: "/apply-arbitrator",
              },
            }}
          />
          <BreadcrumbSec
            crumbs={[{ label: "Home", link: "/" }, { label: "Arbitrator" }]}
          />
          {mediationPageData?.showConceptSection && (
            <ArbitratorConcept {...mediationPageData} />
          )}

          <section className="services-fee-section common-section py-100 pt-0">
            <Container>
              <Row className="align-items-center justify-content-between">
                <Col lg={4}>
                  <div className="image-wrapper mb-lg-0 mb-4">
                    <Image
                      src={Images.FacilitiesSlide2}
                      alt="Service Requirements"
                      loading="lazy"
                      fluid
                    />
                  </div>
                </Col>
                <Col lg={7}>
                  <h2 className="mb-3">What Are The Minimum Requirements?</h2>
                  <p className="mb-0">
                    Candidates must meet one of the following minimum
                    requirements (subject to change and annual review):
                  </p>
                  <p>
                    He/she is certified as a Chartered Arbitrator (C.Arb) or a
                    Fellow (FCIArb) with the Chartered Institute of Arbitrators
                    (Ciarb);
                  </p>
                  <h5>15 February will be announced by 15 April.</h5>
                  <h5>
                    He/she sat as an arbitrator on at least five cases of which
                    at least one was administered by an accredited arbitral
                    institution, and he/she has issued at least two awards in
                    the last five years.
                  </h5>
                  <h5>
                    He/she sat as an arbitrator on at least five cases of which
                    at least one was administered by an accredited arbitral
                    institution, and he/she has issued at least two awards in
                    the last five years.
                  </h5>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="beneficiaries-section common-section py-100 pt-0">
            <Container>
              <Row className="align-items-center justify-content-between">
                <Col lg={7}>
                  <h2 className="mb-3"> How Do I Apply?</h2>
                  <p>
                    Candidates must meet one of the following minimum
                    requirements (subject to change and annual review): He/she
                    is certified as a Chartered Arbitrator (C.Arb) or a Fellow
                    (FCIArb) with the Chartered Institute of Arbitrators
                    (Ciarb); or He/she is certified as a Member (MCIArb) with
                    Ciarb and sat as an arbitrator on at least three cases of
                    which one has ended in a reasoned award within the last
                    three years; or He/she sat as an arbitrator on at least five
                    cases of which at least one was administered by an
                    accredited arbitral institution, and he/she has issued at
                    least two awards in the last five years. NOTE: Meeting the
                    above requirements does not lead to automatic admission.
                  </p>
                </Col>
                <Col lg={4}>
                  <div className="image-wrapper mb-lg-0 mb-4">
                    <Image
                      src={Images.FacilitiesSlide1}
                      alt="Mediation Beneficiaries"
                      loading="lazy"
                      fluid
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="service-requirements-section common-section py-100 pt-0">
            <Container>
              <Row className="align-items-center justify-content-between">
                <Col lg={4}>
                  <div className="image-wrapper mb-lg-0 mb-4">
                    <Image
                      src={Images.FacilitiesSlide3}
                      alt="Mediation Beneficiaries"
                      loading="lazy"
                      fluid
                    />
                  </div>
                </Col>
                <Col lg={7}>
                  <h2 className="mb-3">What Should I Upload When Applying?</h2>
                  <p>
                    Candidates should upload the following documents:
                    <br />
                    Resume stating experience, education, and training in
                    adequate detail (an English version of the resume is
                    preferred); A copy of the candidate’s Passport or
                    Identification Card; Any Ciarb certificates reflecting the
                    current membership status and rank; Any other academic or
                    experience certificates that demonstrate the level of
                    mediation experience.
                  </p>
                  <ul className="general-list">
                    <li>
                      Certificates, recognitions, and publications indicating
                      leadership in the field of expertise;
                    </li>
                    <li>Membership in professional associations;</li>
                    <li>
                      A cover letter that exhibits the level of experience as
                      arbitrator or other relevant arbitration experience (to
                      the extent not already reflected in the resume);
                    </li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </section>

          {mediationPageData?.showFeedbackSection && (
            <ActionFeedback {...mediationPageData} />
          )}
          {mediationPageData?.showDownloadCount && (
            <PageStats
              updatedAt={mediationPageData?.updatedAt}
              countAction={updateDownloadCount}
              downloadCount={mediationPageData?.downloadCount}
              fileViewCount={mediationPageData?.fileViewCount}
              viewCount={mediationPageData?.pageViewCount}
              pdf={mediationPageData?.pdfFile}
              id={mediationPageData?.id}
              loader={mediationPageData?.loader}
            />
          )}
        </>
      )}
    </>
  );
};

export default Arbitrator;
